import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MarkShowcaseProps {
  mark: ReactNode;
  bgColor: string;
  textColor: string;
  name: string;
  usage: string;
  description: string;
  className?: string;
}

export function MarkShowcase({
  mark,
  bgColor,
  textColor,
  name,
  usage,
  description,
  className,
}: MarkShowcaseProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 border border-[#293129]/20">
      <div
        className={cn("p-12 flex items-center justify-center", className)}
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {mark}
      </div>
      <div className="md:col-span-2 p-8 md:p-12 flex flex-col justify-center">
        <h4 className="font-serif text-3xl mb-4">{name}</h4>
        <p className="tracking-widest uppercase text-[10px] font-bold opacity-50 mb-4">{usage}</p>
        <p className="text-xs tracking-[0.2em] leading-loose opacity-80">{description}</p>
      </div>
    </div>
  );
}
